<template>
  <div class="custom-case">
    <div class="plate-title">
      <span><img src="../../assets/svg/custom-case-title.svg" /></span>
      <p>选择困难？瞅一下，别人家的团建怎么玩～</p>
    </div>
    <div class="swiper-wrapper">
      <swiper
        v-if="caseList.length > 0"
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
      >
        <swiper-slide
          class="slide-1"
          v-for="(item, index) in caseList"
          :key="index"
          @click.native.stop="gotoCaseDetail(item.id)"
        >
          <div class="swiper-content">
            <img
              v-bind:style="{ backgroundImage: 'url(' +'\''+ item.image +'\''+ ')' }"
            />
            <div class="swiper-bottom">
              <p class="title">{{ item.title }}</p>
              <p class="description">{{ item.subtitle }}</p>
            </div>
          </div>
        </swiper-slide>
        <div
          class="swiper-button-next swiper-button-gray"
          slot="button-next"
        ></div>
        <div
          class="swiper-button-prev swiper-button-gray"
          slot="button-prev"
        ></div>
      </swiper>
    </div>
    <div class="case-logo-group">
      <el-row
        :gutter="20"
        class="case-logo-second-group"
        v-for="(companyItem, companyIndex) in companyList"
        :key="companyIndex"
      >
       <el-col v-for="(item, index) in companyItem" :key="index">
          <div
            class="case-logo"
            @click="goCaseDetailByCompanyId(item.id)"
            >
          <img class="" v-lazy="item.image"/>
          </div>
          <!-- <div
            
          >{{item.companyName}}</div> -->
        </el-col> 
      </el-row>
      <div class="show-all"><span @click="goCaseList">全部案例</span></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handlePic, handlePicPlusPre } from "../../util/util";
export default {
  name: "adDetails",
  components: {},
  props: {},
  data() {
    return {
      id: null,
      message: {},
      // 公司图标列表
      companyList: [],
      // 案例列表
      caseList: [],
      swiperLoading: false,
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerView: 3, // 容器同时显示的数量
        slidesPerGroup: 3, // 定义slides的数量多少为一组，同时移动3个
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        swiperLoading: false,
      },
      swiperOptionThumbs: {
        autoplay: true,
        direction: "vertical",
        spaceBetween: 5,
        slidesPerView: "auto",
        centeredSlides: true,
        touchRatio: 0.2,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slideToClickedSlide: true,
      },
    };
  },
  watch: {},
  computed: {
    // getScrolltop() {
    //   let _this = this;
    //   window.addEventListener("scroll", () => {
    //     _this.top =
    //       document.documentElement.scrollTop ||
    //       document.body.scrollTop ||
    //       window.pageYOffset;
    //   });
    //   return _this.top > 300;
    // },
    getPreUrl() {
      return this.$store.state.picPreUrl;
    },
  },
  methods: {
    // 处理图片
    handlePic,
    handlePicPlusPre,
    // 去案例详情
    gotoCaseDetail(id) {
      this.$router.push({
        path: "/caseDetail",
        query: { id: id },
      });
    },
    goCaseDetailByCompanyId(id) {
      this.$router.push({
        path: "/caseList",
        query: { companyId: id },
      });
    },
    goCaseList() {
      this.$router.push({
        path: "/caseList",
      });
    },
    getCaseList() {
      const params = {
        pageNum: 1,
        pageSize: 12,
      };
      axios
        .get(`/api/case/indexList`, {
          params,
        })
        .then((res) => {
          console.log(res);
          if (res.data && res.data.code == 200) {
            this.total = res.data.total;
            this.caseList = res.data.rows;
            if (this.caseList) {
              this.caseList.forEach((caseItem) => {
                if (caseItem.image) {
                  caseItem.image = handlePicPlusPre(caseItem.image);
                  caseItem.image = caseItem.image[0];
                }
              });
            }
          }
        });
    },
    getCompanyList() {
      let params = {
        position: "1",
      };
      axios
        .get(`/api/company/list`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.companyList = res.data.adList;
            this.companyList = this.handleCompanyList(this.companyList);
            // console.log(this.companyList);
          } else {
            this.$message("系统繁忙，请稍后再试~");
          }
          this.loading = false;
        });
    },
    // 处理公司列表
    handleCompanyList(companyList) {
      console.log("companyList");
      console.log(companyList);
      if (companyList) {
        let firstCompanyList = [];
        let secondCompanyList = [];
        for (let index = 0; index < companyList.length; index++) {
          const element = companyList[index];
          if (element.image) {
            let imageList = handlePic(element.image);
            if (imageList && imageList.length > 0) {
              element.image = this.getPreUrl + imageList[0];
            }
          }else{
            element.image = "";
          }
          secondCompanyList.push(element);
          if (
            ((index + 1) % 6 == 0 && index != 0) ||
            index == companyList.length - 1
          ) {
            firstCompanyList.push(secondCompanyList);
            secondCompanyList = [];
          }
        }
        console.log("firstCompanyList");
        console.log(firstCompanyList);
        return firstCompanyList;
      } else {
        return [];
      }
    },
  },
  created() {
    //
    this.getCaseList();
    this.getCompanyList();
  },
  mounted() {},
};
</script>
<style scoped>
.custom-case {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.custom-case .plate-title {
  min-height: 160px;
}
.custom-case .plate-title span {
  display: inline-block;
  text-align: center;
  width: 100%;
  font-size: 38px;
  color: #201f1f;
  padding-top: 50px;
}
.custom-case .plate-title p {
  display: inline-block;
  text-align: center;
  width: 100%;
  font-size: 18px;
  color: #666;
  padding-top: 20px;
  padding-bottom: 40px;
}
.custom-case .case-logo-group {
  width: 1060px;
}
.custom-case .case-logo-second-group {
  width: 80%;
  left: 10%;
  position: relative;
  display: flex;
  flex-direction: row;
  /* align-items: center;
  align-content: center;
  justify-items: center; */
  justify-content: center;
}
.custom-case .case-logo {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  height: 80px;
  width: 160px;
  margin-right: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  filter: grayscale(90%);
  opacity: 0.7;
  cursor: pointer;
  /* background-size: cover;
  background-position: center; */
}
.custom-case .case-logo img{
  width: 100%;
  height: 100%;
  /* -o-object-fit: cover;
  object-fit: cover; */
}
/* .custom-case .case-logo img:hover{
  background-size: cover;
  background-position: center;
} */
.case-logo:hover {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  height: 80px;
  width: 160px;
  margin-right: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  filter: grayscale(0%);
  opacity: 1;
}
.el-col {
  margin: 10px;
  width: 160px;
}
.custom-case .show-all {
  text-align: center;
  width: 100%;
  padding: 40px 0;
}
.custom-case .show-all span {
  background: #f2f2f2;
  border-radius: 6px;
  font-size: 16px;
  color: #222;
  padding: 12px 118px;
  cursor: pointer;
}
.swiper-wrapper {
  margin: 10px 200px;
  min-width: 600px;
  width: 1072px;
}
.swiper-wrapper .swiper-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fff;
  cursor: pointer;
}

.swiper-wrapper .swiper-content img {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  transition: all 0.3s ease-in-out;
}
.swiper-wrapper .swiper-content .swiper-bottom .title {
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  color: #222;
  font-weight: 700;
  width: 100%;
  display: inline-block;
  padding: 3px 0px 0 0px;
  /* margin-left: 18px;
  text-align: left; */
}
.swiper-wrapper .swiper-content .swiper-bottom .description {
  font-size: 12px;
  color: #222;
  padding: 0px 30px 0 20px;
  box-sizing: border-box;
  text-align: left;
  height: 60px;
  margin-top: 0px;
  width: 343px;
  line-height: 20px;
  overflow: hidden;
  /* display: -webkit-box; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.swiper-wrapper .swiper-content {
  background: #fff;
  width: 343px;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  height: 334px;
}
.swiper-wrapper :nth-child(2n-1) .swiper-content {
  margin: 0px 8px !important;
}
/*swiper*/
.swiper-wrapper .swiper-button-gray {
  z-index: 1000;
  transition: all 0.2s ease-in-out;
  opacity: 0;
  color: #fff7;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 30px;
}
.swiper-wrapper:hover .swiper-button-gray {
  z-index: 1000;
  transition: all 0.2s ease-in-out;
  opacity: 1;
  color: #fff7;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 30px;
}
.gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .slide-1 {
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.gallery-top .slide-1 a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.gallery-thumbs {
  position: absolute;
  right: 50px;
  top: 150px;
  width: 100px;
  height: 190px;
  padding: 0 5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
}
.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 5px;
  border: #cccccc 1px solid;
  background: transparent;
  border-radius: 6px;
}
.sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 150px !important;
  color: #359ff8;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: #359ff8;
  cursor: pointer;
  width: 90px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/customCase.vue